import React from "react";
import { Link } from "react-router-dom";

/**
 * Reusable sub-page hero used by all detail and legal routes.
 */
const SubPageHero = ({ index, label, title, description, breadcrumb }) => {
  return (
    <section className="relative pt-40 lg:pt-48 pb-16 lg:pb-20 border-b border-[var(--kr-line-soft)] kr-atmosphere overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(28,34,48,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(28,34,48,0.3) 1px, transparent 1px)",
          backgroundSize: "84px 84px",
          maskImage:
            "radial-gradient(ellipse at 30% 30%, black 30%, transparent 80%)",
          WebkitMaskImage:
            "radial-gradient(ellipse at 30% 30%, black 30%, transparent 80%)",
        }}
      />
      <div
        aria-hidden
        className="absolute -top-32 -right-32 w-[520px] h-[520px] rounded-full opacity-[0.18] blur-[110px]"
        style={{
          background:
            "radial-gradient(circle, rgba(201,169,110,0.5), transparent 70%)",
        }}
      />

      <div className="relative max-w-[1480px] mx-auto px-6 lg:px-12">
        {/* Breadcrumb */}
        <div className="flex items-center gap-4 mb-8 font-mono-label text-[10px] text-[var(--kr-text-muted)]">
          <Link to="/" className="hover:text-[var(--kr-gold)] transition-colors">
            Home
          </Link>
          <span className="text-[var(--kr-text-dim)]">/</span>
          <span className="text-[var(--kr-gold)]">{breadcrumb}</span>
        </div>

        {/* Eyebrow */}
        <div className="flex items-center gap-4 mb-8">
          <span className="font-mono-label text-[10px] text-[var(--kr-gold)]">
            {index}
          </span>
          <span className="w-12 h-px bg-[var(--kr-gold)]/60" />
          <span className="font-mono-label text-[11px] text-[var(--kr-text-muted)]">
            {label}
          </span>
        </div>

        <h1 className="font-serif-display text-[var(--kr-text)] text-[clamp(2.2rem,5.2vw,4.8rem)] max-w-[22ch] leading-[1.05]">
          {title}
        </h1>

        {description ? (
          <p className="mt-8 text-[var(--kr-text-muted)] text-[17px] leading-[1.85] max-w-[62ch]">
            {description}
          </p>
        ) : null}
      </div>
    </section>
  );
};

export default SubPageHero;
